import StampWriteOff from '../../../../types/api/stamp-write-off'
import { StrapiCreate } from '../../../../types/strapi/strapi'
import FormValues from '../types/form-values'

export default function extractCreateStampWriteOff(
    values: FormValues
): StrapiCreate<StampWriteOff> {
    const body: StrapiCreate<StampWriteOff> = {
        data: {
            stamp: { set: [values.stamp] },
            reason: values.reason,
            initiator: { set: values.initiator ? [values.initiator] : [] },
        },
    }

    return body
}
